export default "__VITE_ASSET__CE_VH9n7__"